/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'com.atproto.server.defs'

export { $nsid }

type InviteCode = {
  $type?: 'com.atproto.server.defs#inviteCode'
  code: string
  available: number
  disabled: boolean
  forAccount: string
  createdBy: string
  createdAt: l.DatetimeString
  uses: InviteCodeUse[]
}

export type { InviteCode }

const inviteCode = l.typedObject<InviteCode>(
  $nsid,
  'inviteCode',
  l.object({
    code: l.string(),
    available: l.integer(),
    disabled: l.boolean(),
    forAccount: l.string(),
    createdBy: l.string(),
    createdAt: l.string({ format: 'datetime' }),
    uses: l.array(l.ref<InviteCodeUse>((() => inviteCodeUse) as any)),
  }),
)

export { inviteCode }

type InviteCodeUse = {
  $type?: 'com.atproto.server.defs#inviteCodeUse'
  usedBy: l.DidString
  usedAt: l.DatetimeString
}

export type { InviteCodeUse }

const inviteCodeUse = l.typedObject<InviteCodeUse>(
  $nsid,
  'inviteCodeUse',
  l.object({
    usedBy: l.string({ format: 'did' }),
    usedAt: l.string({ format: 'datetime' }),
  }),
)

export { inviteCodeUse }
